import { IFoDotDangKyAn, IDotDangKyResponse } from "../../../models/response/thuc-don/IFoDotDangKyAn";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objDotDangKyAnDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IFoDotDangKyAn[],
    LOAD_ERROR: "",
    LOAD_BY_COSO_NAMHOC_START: { dm_coso_id: 0, nam_hoc: "" },
    LOAD_BY_COSO_NAMHOC_SUCCESS: [] as IDotDangKyResponse[],
    LOAD_BY_COSO_NAMHOC_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFoDotDangKyAn | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFoDotDangKyAn,
    SAVE_SUCCESS: {} as IFoDotDangKyAn,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
};

export const eFoDotDangKyAnActionTypeIds = generateActionTypeIds(objDotDangKyAnDefine, "DOT_DANG_KY_AN");

export type IFoDotDangKyAnActionTypes = IGenericActionType<typeof objDotDangKyAnDefine, "DOT_DANG_KY_AN">;
